/*
 * @Descripttion:
 * @Author: zhanghang
 * @Date: 2021-07-21 14:31:58
 * @LastEditors: zhanghang
 * @LastEditTime: 2022-10-18 17:50:14
 */
// import DsfPlatformPolyline from './polyline.vue'
// import DsfPlatformBar from './bar.vue'
// import DsfPlatformPie from './pie.vue'
// import DsfPlatformMixinAxis from './mixinAxis.vue'
// import DsfPlatformRadar from './radar.vue'
// import DsfPlatformMapChart from './mapChart.vue'
// import DsfPlatformScatter from './scatter.vue'
const DsfPlatformPolyline = dsf.defineAsyncComponent("DsfPlatformPolyline", () => import(/*webpackChunkName:"platform_pc_other"*/"./polyline.vue"));
const DsfPlatformBar = dsf.defineAsyncComponent("DsfPlatformBar", () => import(/*webpackChunkName:"platform_pc_other"*/"./bar.vue"));
const DsfPlatformPie = dsf.defineAsyncComponent("DsfPlatformPie", () => import(/*webpackChunkName:"platform_pc_other"*/"./pie.vue"));
const DsfPlatformMixinAxis = dsf.defineAsyncComponent("DsfPlatformMixinAxis", () => import(/*webpackChunkName:"platform_pc_other"*/"./mixinAxis.vue"));
const DsfPlatformRadar = dsf.defineAsyncComponent("DsfPlatformRadar", () => import(/*webpackChunkName:"platform_pc_other"*/"./radar.vue"));
const DsfPlatformMapChart = dsf.defineAsyncComponent("DsfPlatformMapChart", () => import(/*webpackChunkName:"platform_pc_other"*/"./mapChart.vue"));
const DsfPlatformScatter = dsf.defineAsyncComponent("DsfPlatformScatter", () => import(/*webpackChunkName:"platform_pc_other"*/"./scatter.vue"));
const DsfPlatformProxyChart = dsf.defineAsyncComponent("DsfPlatformProxyChart", () => import(/*webpackChunkName:"platform_pc_other"*/"./proxyChart.vue"));

const components = {
  DsfPlatformPolyline,
  DsfPlatformBar,
  DsfPlatformPie,
  DsfPlatformMixinAxis,
  DsfPlatformRadar,
  DsfPlatformMapChart,
  DsfPlatformScatter,
  DsfPlatformProxyChart
};

const install = dsf.createDsfVueInstall("platform", components);
export default {
  install
};
